<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Reports</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">

        </div>
      </div>
    </div>
    <div>
      <inventory-reports></inventory-reports>
    </div>
  </div>
</template>

<script>
import InventoryReports from '@/components/inventory/reports/index'
export default {
  components: { InventoryReports },
}
</script>

<style>

</style>
